export const CAROUSEL_AD_LIST = 'home/carouselAdList';
export const COMMON_AD_LIST = 'home/commonAdList';
export const NEWS_PAGER_LIST = 'home/newsPagerList';
export const USER_LIKE_PRODUCTS_LIST = 'home/userLikeProductsList';
export const CLEAR_USER_LIKE_PRODUCTS_LIST = 'home/clearUserLikeProductsList';
export const WEIXIN_LOGIN = 'login/WEIXIN_LOGIN';


export const INDEX_LIST = 'home/indexList';